import { Box, Button, IconButton, Typography } from "@mui/material"
import { useTranslation } from "react-i18next"
import { useStyles } from "./styles"
import StepperCreate from "../../../../components/stepperCreate"
import { useContextState } from "../../../../hooks/theme"
import { icons } from "../../../../utils/icons"
import { useNavigate } from "react-router-dom"
import { useState } from "react"
import SimpleModal from "../../../../components/modal/simpleModal"
import { CustomPaper } from "../../../../components/CustomPaper"
import { BasicConfiguration } from "./components/step1"
import { useBody } from "./hooks/body"
import { Permissions } from "./components/step2"
import { useInput } from "./hooks/useInput"
import { useTables } from "./hooks/useTable"
import { useFilterTabel } from "./hooks/useFilterTable"
import { TabsChildren } from "../../../logbook/pages/main/components/access/utils/enums/tabs"
import { LoadingButton } from "@mui/lab"
import { filesManagerServiceFetch } from "../../../../utils/constants/callService"
import { createFileBody } from "../../../../service/filesManager/body"
import { RequestErrors, Types } from "../../../../utils/enums"
import { SnackSimple } from "../../../../components"
import { handleAllErrors } from "../../../../utils/methods/handleErrors"


export const CreateFile = () => {

    const styles = useStyles()
    const { t } = useTranslation()
    const { colors } = useContextState()
    const navigate = useNavigate()
    const [steps, setSteps] = useState<number>(0)
    const [loadingSave, setLoadingSave] = useState(false)
    const [openSnackbar, setOpenSnackbar] = useState({
        open: false,
        message: '',
        type: Types.SUCCESS,
    })
    const [modal, setModal] = useState<{
        open: boolean
        title: string
        description?: string
        children?: JSX.Element
        removeCancel?: boolean
        confirm: () => void
    }>({
        open: false,
        title: t('filesManager.modal.titles.confirmation'),
        description: '',
        confirm: () => { },
    })

    const closeModalIndex = () => {
        setModal(prev => ({
            ...prev,
            open: false,
        }))
    }

    //Step2
    const [userSelected, setUserSelected] = useState<Record<string, boolean>>({})
    const [value, setValue] = useState(TabsChildren.USERS)
    const { input, inputUser, userFilter, createFilter, modalLoad, loadings, cancelSearchUsers, searchUsers, loadUsers, closeSnackbar, snackbar, dataUsers, inputFilter, permissionFilter, } = useInput({ setUserSelected, userSelected })
    const { filterRow } = useFilterTabel()
    const {
        column: columnFolio, row: rowFolio, openModal, userFolioSelected, closeModal, rowFiltered, setAllSettingsFolioUser, deleteSelected, deletedUsersSelecteds, setDeletedSelected,
    } = useTables({ tab: value, dataUsers, setUserSelected, userSelected, dataFilter: permissionFilter.filterData, filterRow })

    //Step 1
    const body = useBody({userFilter, setModal, setOpenSnackbar, closeModalIndex});

    const unselectOrSelectAllUserManage = ({ value }: { value: boolean }) => {
        let body: Record<
            string,
            {
                seeFile?: boolean
                downloadFile?: boolean
            }
        > = structuredClone(userFolioSelected)

        const filter = filterRow({ list: rowFolio, value: permissionFilter.filterData })

        filter?.forEach((item) => {
            body = {
                ...body,
                [item.id?.toString() ?? '']: {
                    ...userFolioSelected[item.id?.toString() ?? ''],
                    seeFile: value,
                    downloadFile: value
                },
            }
        })

        return { body, filter }
    }

    const unSelectOrSelectAllUsersFolios = ({ value }: { value: boolean }) => {
        const { body, filter } = unselectOrSelectAllUserManage({ value })
        setAllSettingsFolioUser({ userFolio: body, skip: !value, filter })
    }

    const goBackToList = () => {
        setModal(prev => ({
            ...prev,
            open: true,
            title: t('filesManager.modal.titles.backToList'),
            description: t('filesManager.modal.description.toBackTheChangesLost'),
            confirm: () => {
                navigate('/dashboard/filesManager/main');
            }
            //Agregar acá la funcion para eliminar
        }))

    }


    const stepBack = () => {
        handleSteps(-1)
    }

    const stepForward = () => {
        handleSteps(1)
    }

    const handleSteps = async (step: number) => {

        if (step == -1 && steps == 0) {
            setModal(prev => ({
                ...prev,
                open: true,
                title: t('filesManager.modal.titles.backToList'),
                description: t('filesManager.modal.description.toBackTheChangesLost'),
                confirm: () => {
                    navigate('/dashboard/filesManager/main');
                }
            }))

            return;
        }

        if (step == 1 && steps == 1) {
            setModal(prev => ({
                ...prev,
                open: true,
                title: t('filesManager.modal.titles.confirmation'),
                description: t('filesManager.modal.description.areYouSureToSaveThisFile'),
                confirm: () => {
                    handleSubmitFile();
                    closeModalIndex()
                }
            }))
            return;
        }


        setSteps(steps + step)
    }

    const handleSubmitFile = async () => {
        setLoadingSave(true)
        const formData  = createFileBody({ data: body.data, file: body.file, userPermissions: userFolioSelected, requestingUsers: body.requestingUsers })
        const response = await filesManagerServiceFetch.createFile( formData  )
        if (!response.errors) {
            setSteps(2)
        } else {
            setOpenSnackbar({ ...openSnackbar, open: true, message: handleAllErrors(response.errors[0].code as RequestErrors, t), type: Types.ERROR })
        }
        setLoadingSave(false)
    }

    const handleCloseSnackbar = (value: boolean) => setOpenSnackbar({ ...openSnackbar, open: value })

    const stepsArray = [
        {
            step: 'Paso 1',
            label: 'Configuración básica',
        },
        {
            step: 'Paso 2',
            label: 'Permisología',
        }
    ]

    const disabled = () => {
        if (steps == 0) {
            return !body.file || !!body.errors.to
        }

        return false
    }

    const CurrentStep = () => {
        switch (steps) {
            case 0:
                return <BasicConfiguration 
                        row={body.row} 
                        isLoading={body.loading} 
                        inputUser={inputUser}
                        userFilter={userFilter}
                        data={body.data} 
                        errors={body.errors} 
                        setData={body.setData} 
                        setErrors={body.setErrors} 
                        file={body.file} 
                        setFile={body.setFile} 
                        searchUsersSolicited={body.searchUsersSolicited}
                        column={body.column}
                    />
            case 1:
                return <Permissions
                    setValue={setValue}
                    value={value}
                    columnFolio={columnFolio}
                    deleteSelected={deleteSelected}
                    deletedUsersSelecteds={deletedUsersSelecteds}
                    loadingTable={false}
                    permissionFilter={permissionFilter}
                    rowFiltered={rowFiltered}
                    setDeletedSelected={setDeletedSelected}
                    unSelectOrSelectAllUsersFolios={unSelectOrSelectAllUsersFolios}
                    closeModal={closeModal}
                    closeSnackbar={closeSnackbar}
                    inputFilter={inputFilter}
                    openModal={openModal}
                    snackbar={snackbar}
                    cancelSearchUsers={cancelSearchUsers}
                    createFilter={createFilter}
                    input={input}
                    loadUsers={loadUsers}
                    loadings={loadings}
                    modalLoad={modalLoad}
                    searchUsers={searchUsers}
                />
            case 2:
                return (
                    <Box sx={styles.containerFinal}>
                        <Typography sx={styles.icon}>{icons('check-outlined')}</Typography>
                        <Typography variant='big' fontWeight='medium-bold'>{t('filesManager.titles.fileCreatedSuccess')}</Typography>
                        <Button onClick={() => { navigate('/dashboard/filesManager/main') }} className="continue" variant="contained" >
                            {t('filesManager.buttons.backToFilesList')}
                        </Button>
                    </Box>
                )
            default:
                return null
        }
    }


    return (
        <Box sx={styles.container}>
            <Box sx={styles.header}>
                <Box>
                    <Box sx={styles.headerLeft}>
                        <IconButton onClick={goBackToList}>{icons('arrow-left-fill')}</IconButton>
                        <Typography>{t('filesManager.buttons.backToList')}</Typography>
                    </Box>

                    <Box>
                        <Typography sx={styles.title}>{t('filesManager.titles.createFile')}</Typography>
                    </Box>
                </Box>

                <Box sx={styles.stepper}>
                    <StepperCreate color={colors} steps={stepsArray} activeStep={steps} />
                </Box>
            </Box>

            <CustomPaper elevation={2} sx={styles.paper}>
                {steps !== 2 && <Box sx={styles.containerButtons}>
                    <Button onClick={stepBack}>{steps == 0 ? t('general.cancel') : t('filesManager.buttons.back')}</Button>

                    <LoadingButton loading={steps == 1 ? loadingSave : false} disabled={disabled()} className="next" variant="contained" onClick={stepForward}>
                        {steps == 0 ? t('general.continue') : t('general.save')}
                    </LoadingButton>
                </Box>}

                <Box sx={styles.currentStep}>{CurrentStep()}</Box>
            </CustomPaper>

            <SnackSimple close={handleCloseSnackbar} open={openSnackbar.open} type={openSnackbar.type} message={openSnackbar.message} />

            <SimpleModal
                open={!!modal.open}
                next={modal.confirm}
                back={closeModalIndex}
                close={closeModalIndex}
                description={modal.description}
                buttonText={t('general.confirm')}
                cancelText={t('general.cancel')}
                title={modal.title}
                loadingButton={false}
            />
        </Box>
    )
}